import "./ErrorPage.css";
import React from "react";

const ErrorPage = () => {
  return (
    <div className="error-body">
      מצטערים, <br />
      המשרה שחיפשת לא קיימת. <br />
      לצפייה במשרות נוספות:{" "}
      <a href="https://b-e.org.il/%d7%a7%d7%a8%d7%99%d7%99%d7%a8%d7%94/%d7%97%d7%99%d7%a4%d7%95%d7%a9-%d7%9e%d7%a9%d7%a8%d7%95%d7%aa/">בית אקשטיין</a>
    </div>
  );
};

export default ErrorPage;
